var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "previred-facial-recognition" }, [
    _c("div", { staticClass: "sw-step" }, [
      _c("h3", { staticClass: "title-get-code" }, [
        _vm._v("Valida tu identidad"),
      ]),
      _vm.showInfo
        ? _c("div", { staticClass: "second-factor-info" }, [
            _c("p", { staticClass: "text-get-code" }, [
              _vm._v(
                " Por tu seguridad, necesitamos confirmar tu identidad mediante reconocimiento facial y un código de verificación antes de continuar. "
              ),
            ]),
            _vm._m(0),
            _vm._m(1),
            _c(
              "button",
              {
                staticClass: "fulfillment-button",
                attrs: { id: "accept-auth-method" },
                on: { click: _vm.createAuthMethod },
              },
              [_vm._v(" Comenzar validación ")]
            ),
          ])
        : _vm.showAuthWidget
        ? _c(
            "div",
            { staticClass: "auth" },
            [
              _c("FulfillmentAuthentication", {
                attrs: {
                  rut: _vm.rut,
                  company: "cuprum",
                  method: "facialRecognition",
                  "dummy-mode": _vm.dummyMode,
                  "kong-token": _vm.kongToken,
                  "kong-client-id": _vm.kongClientId,
                  "kong-client-secret": _vm.kongClientSecret,
                  environment: _vm.environment,
                  "facial-timer": _vm.facialTimer,
                  "channel-key": _vm.channelKey,
                },
                on: {
                  auth: _vm.onAuthentication,
                  goBack: function ($event) {
                    return _vm.$emit("goBack")
                  },
                },
              }),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "previred" },
            [
              _vm.isPollingOn && !_vm.hasErrors
                ? _c(
                    "Result",
                    {
                      attrs: {
                        title: "Tu identidad ha sido validada",
                        body: "Por favor espera, estamos obteniendo tus datos de afiliado",
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "hourglass",
                        attrs: {
                          slot: "image",
                          src: "https://static.dx.cuprum.cl/fulfillment/assets/previred/hourglass.png",
                          alt: "waiting",
                        },
                        slot: "image",
                      }),
                    ]
                  )
                : _vm._e(),
              !_vm.isPollingOn && !_vm.hasErrors
                ? _c(
                    "Result",
                    {
                      attrs: {
                        title: "Tus datos han sido obtenidos",
                        body: "Ya puedes migrar a CuprumAFP",
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          slot: "image",
                          src: "https://static.dx.cuprum.cl/fulfillment/assets/auth/kba/success_image.svg",
                          alt: "success_image",
                        },
                        slot: "image",
                      }),
                    ]
                  )
                : _vm._e(),
              _vm.hasErrors
                ? _c(
                    "Result",
                    {
                      attrs: {
                        title: "No es posible verificar tu información",
                        body:
                          _vm.errorDetail ||
                          "Por la seguridad de tu información no es posible continuar.",
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          slot: "image",
                          src: "https://static.dx.cuprum.cl/fulfillment/assets/auth/kba/error_image.svg",
                          alt: "error_image",
                        },
                        slot: "image",
                      }),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "factor-detail" }, [
      _c("div", [
        _c("span", { staticClass: "factor-detail-pretitle" }, [
          _vm._v("Método 1"),
        ]),
        _c("h3", { staticClass: "factor-detail-title" }, [
          _c("img", {
            attrs: {
              src: require("../assets/scan-face 1.png"),
              alt: "icon scan face",
            },
          }),
          _vm._v(" Reconocimiento Facial "),
        ]),
        _c("p", { staticClass: "factor-detail-text" }, [
          _vm._v(" Ten a mano tu cédula de identidad y tu teléfono celular "),
        ]),
      ]),
      _c("img", {
        staticClass: "fill-icon",
        attrs: { src: require("../assets/Fill.png"), alt: "fill icon" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "factor-detail" }, [
      _c("div", [
        _c("span", { staticClass: "factor-detail-pretitle" }, [
          _vm._v("Método 2"),
        ]),
        _c("h3", { staticClass: "factor-detail-title" }, [
          _c("img", {
            attrs: { src: require("../assets/key 1.png"), alt: "icon key" },
          }),
          _vm._v(" Código de verificación "),
        ]),
        _c("p", { staticClass: "factor-detail-text" }, [
          _vm._v(
            " Se enviará un código de 6 dígitos a tu correo electrónico registrado en Cuprum AFP. "
          ),
        ]),
      ]),
      _c("img", {
        staticClass: "fill-icon",
        attrs: { src: require("../assets/Fill.png"), alt: "fill icon" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }